export const ACCOUNT_PROPERTY_GET = 'ACCOUNT_PROPERTY_GET'
export const ACCOUNT_PROPERTY_MAP = 'ACCOUNT_PROPERTY_MAP'
export const ACCOUNT_PROPERTIES = 'ACCOUNT_PROPERTIES'
export const ACCOUNT_PROPERTY_IMPORT = 'ACCOUNT_PROPERTY_IMPORT'
export const ACCOUNT_PROPERTY_DELETE = 'ACCOUNT_PROPERTY_DELETE'
export const PROPERTY_IMPORT_STATUS = 'PROPERTY_IMPORT_STATUS'
export const PROPERTY_IMPORT_HISTORY = 'PROPERTY_IMPORT_HISTORY'
export const PROPERTY_IMPORT_COLUMNS = 'PROPERTY_IMPORT_COLUMNS'
export const PROPERTY_IMPORT_CANCEL = 'PROPERTY_IMPORT_CANCEL'
export const ACCOUNT_PROPERTY_RISK_CONTROL_GET = 'ACCOUNT_PROPERTY_RISK_CONTROL_GET'
export const ACCOUNT_PROPERTY_RISK_CONTROL_DELETE = 'ACCOUNT_PROPERTY_RISK_CONTROL_DELETE'



// WEBPACK FOOTER //
// ./src/store/actions/properties.js